module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bread-crumb', {
    attrs: {
      "routeName": 'Capabilities',
      "subRoute": _vm.capability_name
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('hero', {
    attrs: {
      "backgroundImage": _vm.slider_image,
      "content": _vm.slider_label
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "is-white subtitle is-5 content",
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.bullet_points), function(point) {
    return _c('li', {
      staticClass: "is-block is-white title is-bold is-5"
    }, [_vm._v("\n          " + _vm._s(point.value) + "\n        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless"
  }, _vm._l((_vm.related), function(capability, index) {
    return _c('div', {
      staticClass: "column",
      class: {
        'm-r-10': index < 2 && _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet),
          'm-b-10': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet),
      }
    }, [_c('card', {
      attrs: {
        "to": ("capabilities/" + (capability.capability_name)),
        "red": true,
        "background": ("https://" + (_vm.baseURL()) + "/" + (capability.slider_image.path)),
        "subtitle": capability.slider_text,
        "title": capability.capability_name,
        "height": "40vh"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44f1e148","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pages/capabilities.vue
// module id = 1141
// module chunks = 1